import { useNavigate } from 'react-router-dom';
import './ContactUs.css';
import logo from '../../assets/images/logo.svg';
import location from '../../assets/images/location.svg';
import mail from '../../assets/images/mail.svg';
import sentBlue from '../../assets/images/sent-blue.svg';
import robotImg from '../../assets/images/robot.png';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import axios from 'axios';
import { axiosInstance } from '../../config/axiosConfig';
import { CONTACT_US_EMAIL } from '../../config/endpoint';
import { toast } from 'react-toastify';

const schema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    organization: Yup.string().required('Organization is required'),
    message: Yup.string().required('Message is required'),
});

function ContactUs() {
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting },
    } = useForm({
        resolver: yupResolver(schema),
    });

    const onSubmit = async (data) => {
        try {
            const response = await axiosInstance.post(CONTACT_US_EMAIL, data);
            toast.success(response.message || 'Message sent successfully!');
            reset();
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to send message.');
        }
    };

    return (
        <div className="home">
            <div className="header">
                <img src={logo} alt="logo" />
                <button className="login-btn" onClick={() => navigate('/login')}>Log In</button>
            </div>

            <div className="contactDetails">
                <div className="contactDetailsBoxWrapper">
                    <div className="contactDetailsBox contact-info">
                        <h6>We’d love to hear from you.</h6>
                        <p className="font-24"><img src={mail} alt="mail" width="20px" /> info@brainyagent.ai</p>
                        <p className="font-24 d-flex align-items-start">
                            <img src={location} alt="location" width="20px" />
                            251 East 32nd Street<br />7C<br />NYC, NY 10016<br />United States
                        </p>
                    </div>

                    <div className="contactDetailsBox bot-image">
                        <img src={robotImg} alt="robot" width="100%" />
                    </div>

                    <div className="contactDetailsBox contact-form">
                        <form onSubmit={handleSubmit(onSubmit)} noValidate>
                            <div>
                                <div className="input-container">
                                    <input
                                        type="text"
                                        className="input"
                                        placeholder="First Name"
                                        {...register('firstName')}
                                    />
                                </div>
                                <p className="error-message">{errors.firstName?.message}</p>
                            </div>

                            <div>
                                <div className="input-container">
                                    <input
                                        type="text"
                                        className="input"
                                        placeholder="Last Name"
                                        {...register('lastName')}
                                    />
                                </div>
                                <p className="error-message">{errors.lastName?.message}</p>
                            </div>

                            <div>
                                <div className="input-container">
                                    <input
                                        type="email"
                                        className="input"
                                        placeholder="Email"
                                        {...register('email')}
                                    />
                                </div>
                                <p className="error-message">{errors.email?.message}</p>
                            </div>

                            <div>
                                <div className="input-container">
                                    <input
                                        type="text"
                                        className="input"
                                        placeholder="Organization"
                                        {...register('organization')}
                                    />
                                </div>
                                <p className="error-message">{errors.organization?.message}</p>

                            </div>

                            <div>
                                <div className="input-container">
                                    <textarea
                                        placeholder="Message"
                                        className="input resize-none"
                                        rows={4}
                                        {...register('message')}
                                    ></textarea>
                                </div>
                                <p className="error-message">{errors.message?.message}</p>
                            </div>

                            <div className="d-flex justify-content-end gap-16 mt-3">
                                <button
                                    type="button"
                                    className="theme-outline-btn py-3"
                                    style={{ borderRadius: '100px' }}
                                    onClick={() => reset()}
                                >
                                    Clean
                                </button>
                                <div>
                                    <button
                                        type="submit"
                                        className="theme-sky-btn py-3"
                                        style={{ borderRadius: '100px' }}
                                        disabled={isSubmitting}
                                    >
                                        <img src={sentBlue} alt="Send" width="100%" />
                                        {isSubmitting ? 'Sending...' : 'Send'}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactUs;
